import React from "react";
import { useState, useEffect } from 'react';
import { fetchWithAuth } from "../../auth"

import '../../index.css';

const ErrorsTableDB = ({
    serial
}) => {
    const [mysqlErrorsState, setMysqlErrorsState] = useState([]);

    async function fetcherrors() {
        await fetchWithAuth('/errors/' + serial, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        })
            .then(data => {
                setMysqlErrorsState(data)
            })
    }

    useEffect(() => {
        fetcherrors()
    }, [serial]);

    async function deleteErrors(event) {
        let _serial = event.target.getAttribute('serial_arg');
        await fetchWithAuth('/errors', {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({ serial: _serial })
        })
            .then(data => {
                    fetcherrors()
            })
    }

    const [isOpen, setIsOpen] = useState(false);

    return (
        <div className={`GatewayDBTable-Section ${isOpen ? 'open' : ''}`}>
            <button onClick={() => setIsOpen(!isOpen)} style={{ marginBottom: '10px', backgroundColor: 'red', color: 'white', fontWeight: 'bold' }}>
                {isOpen ? 'Nascondi Errors' : 'Mostra Errors'}
            </button>
            {isOpen && (
                <table>
                    <tbody>
                        <tr>
                            <th className="tabletitle_db_error" colSpan="3">Errors</th>
                            <th style={{ borderBottom: 'hidden', borderTop: 'hidden', borderRight: 'hidden' }}></th>
                        </tr>
                        <tr>
                            <th className="title">Timestamp</th>
                            <th className="title">Modulo</th>
                            <th className="title">Errore</th>
                            <th style={{ borderBottom: 'hidden', borderRight: 'hidden' }}>
                                <button onClick={deleteErrors} serial_arg={serial}>Pulisci</button>
                                <button onClick={fetcherrors}>Aggiorna</button>
                            </th>
                        </tr>
                        {mysqlErrorsState.reverse().map(mapError => (
                            <tr key={mapError.id}>
                                <td>{new Date(mapError.timestamp).toLocaleString()}</td>
                                <td>{mapError.source}</td>
                                <td>{mapError.message}</td>
                                <td style={{ borderBottom: 'hidden', borderRight: 'hidden' }}>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            )}
        </div>
    );
};

export default ErrorsTableDB;
